/*
 * @Description:
 * @Date: 2025-05-19 18:04:00
 */
import AccountMain from '../views/account-main.vue';
import AccountInfo from '../views/account-info.vue';

export const route = [
  {
    path: '/main/a/account/list',
    name: 'a-account-list',
    meta: {
      title: '账户管理',
      functionCode: 2
    },
    component: AccountMain
  },
  {
    path: '/main/s/account/list',
    name: 's-account-list',
    meta: {
      title: '账户管理',
      functionCode: 3
    },
    component: AccountMain
  },
  {
    path: '/main/a/account/info',
    name: 'a-account-info',
    meta: {
      title: '账户详情',
      parentPath: '/main/a/account/list'
    },
    component: AccountInfo
  },
  {
    path: '/main/s/account/info',
    name: 's-account-info',
    meta: {
      title: '账户详情',
      parentPath: '/main/s/account/list'
    },
    component: AccountInfo
  }
];
